{
  "projects": "Projekte",
  "reports": "Reports",
  "help": "Hilfe & Support",
  "survey": "UX Test: Umfrage",
  "profile": "Dein Profil",
  "settings": "Einstellungen",
  "recommendUs": "Empfehle uns!",
  "signOut": "Abmelden",
  "noMessages": "Keine Nachrichten vorhanden"
}
